/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../../api/index';
import * as core from '../../../../../core';
import * as serializers from '../../../../index';
import { DidcommMessageFilter } from '../../../../types/DidcommMessageFilter';
import { DidcommMessageSort } from '../../../../types/DidcommMessageSort';

export const DidcommMessageSearchRequest: core.serialization.Schema<
    serializers.DidcommMessageSearchRequest.Raw,
    Truvity.DidcommMessageSearchRequest
> = core.serialization.object({
    filter: core.serialization.list(DidcommMessageFilter).optional(),
    sort: core.serialization.list(DidcommMessageSort).optional(),
});

export declare namespace DidcommMessageSearchRequest {
    export interface Raw {
        filter?: DidcommMessageFilter.Raw[] | null;
        sort?: DidcommMessageSort.Raw[] | null;
    }
}
